var E = /{{.*?}}/g,
    A = /({{.*?}}|{{.*)/g,
    R = "{{",
    _ = "}}",
    N = 2,
    P = "MARK",
    o = 200;
export { E as CLOSED_VARIABLE_REGEXP, _ as CLOSING_PARENTHESES, R as OPENING_PARENTHESES, N as PARENTHESES_LENGTH, o as TEXTAREA_POPUP_WIDTH, P as VARIABLE_NODE_NAME, A as VARIABLE_REGEXP };